<template>
    <b-modal size="xl" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
        <div class="modal-body">
            <b-card bg-variant="light">
                <b-form @submit.prevent="handleSubmit">
                    <b-row class="justify-content-center">
                        <b-col cols="12" class="text-right">
                            <b-button id="procurar" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                                variant="primary" @click="load">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="search" />
                                </div>
                                <b-tooltip target="procurar" title="Localizar" triggers="hover focus"></b-tooltip>
                            </b-button>

                            <b-button id="adicionar-local-proibido" class="ml-3 mr-4" size="sm" style="height: 60px"
                                pill variant="primary" @click="showModalLocais">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="plus" />
                                </div>
                                <b-tooltip target="adicionar-local-proibido"
                                    title="Adicionar novo Local de Armazenamento..."></b-tooltip>

                            </b-button>

                        </b-col>
                    </b-row>
                </b-form>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template v-slot:cell(action)="row">
                        <b-button v-b-tooltip.hover.bottom="'Remover...'" :id="row.index + 'excluirLocalProibido'"
                            class=" my-2" size="sm" pill variant="primary" @click="remover(row.item)">
                            <b-icon icon="trash-fill" />
                        </b-button>
                    </template>

                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        Página {{ page }} de {{ totalPage }} - {{ total }} registros
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </div>


        <b-modal size="sm" button-size="sm" hide-footer v-model="mostrarLocais" :title="title + ' > Cadastro' "
            @hidden="fecharModal">

            <b-form @submit.prevent="save">

                <b-card>
                    <b-form-row>
                        <LgFinderPageUnidadeAdministrativa id="departamentoMonitoramentoForm"
                            :prefix="title + + ' > Cadastro > '" v-model="form.departamento" label="Departamento:*" required
                            @onselect="handleSelectUnidadeAdministrativa" />
                    </b-form-row>

                    <b-form-row>
                        <LgFinderPageLocalArmazenamento id="localMonitoramentoForm" :departamento="form.departamento"
                            :disabled="!form.departamento || !form.departamento.id" :prefix="title + + ' > Cadastro > '"
                            v-model="form.local" label="Local Armazenamento:" required @input="handleLocal" />
                    </b-form-row>

                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvar" class=" my-2" size="sm" pill variant="success" @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvar" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="fecharModal">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>


                </b-card>
            </b-form>
        </b-modal>

    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import { ListResourceMixin } from "@/core/mixins/resource"
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue"
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";

export default {
    components: {
        LgFinderPageLocalArmazenamento,
        LgFinderPageUnidadeAdministrativa
    },
    props: {
        prefix: Array,
        id: Number,
    },
    data() {
        return {
            form: {
                departamento: {},
                local: {}
            },
            mostrarLocais: false,
            localArmazenamento: {},
            showModal: true,
            searchText: "",
            searchDate: null,
            busy: false,
        }
    },
    mounted() {
        this.load()
    },
    mixins: [ListResourceMixin, FormResourceMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/ibp-local-nao-autorizado`)
    },
    watch: {
        page() {
            this.load()
        },
    },

    computed: {
        updatedPrefix() {
            return [...this.prefix, "Locais Proibidos"]
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
        tableFields() {
            return [
                {
                    key: "departamento",
                    label: "Departamento",
                },

                {
                    key: "local",
                    label: "Local Armazenamento",
                },
                {
                    key: "action",
                    label: " ",
                    tdClass: "w-1",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                    thClass: "text-left",
                },


            ]
        },
    },
    methods: {
        handleSelectUnidadeAdministrativa(departamento) {
            this.form.departamento = departamento;
        },

        handleLocal(local) {
            this.form.local = local;
        },
        async remover(local) {
            this.busy = true;
            await this.$service.remove(local.id);
            this.$notify({
                type: "success",
                message: "Local de Armazenamento removido com sucesso",
            });
            this.load();

        },
        showModalLocais() {
            this.mostrarLocais = true;
        },
        async save() {

            if (!this.form.departamento || !this.form.departamento.id) {
                this.$notify({
                    type: "danger",
                    message: "Selecione um Departamento",
                });

                return;
            }

            try {
                this.mostrarLocais = false;

                var form = { departamento: this.form.departamento.id, ibp: this.id }

                if (this.form.local && this.form.local.id) {
                    form.local = this.form.local.id;
                }

                this.busy = true;
                await this.$saveResource(form, "", false, {}, false, true);
                this.load();

            }
            catch (error) {
                this.mostrarLocais = false;

                this.busy = false;
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }


        },
        handleSubmit(event) {
            event.preventDefault()
            this.load()
        },
        async load() {
            this.busy = true
            var filtro = {}

            filtro.ibp = this.id;

            await this.$loadResource({
                limit: this.perPage,
                page: this.page,
                params: filtro,
            })
            this.busy = false
        },
        cancelar() {
            this.$emit("close")
        },
        fecharModal() {
            this.mostrarLocais = false;
            this.form = {
                departamento: {},
                local: {}
            };

        }
    },
}
</script>
<style scoped>
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-body {
    padding-top: 1rem;
}
</style>